import { Injectable } from '@angular/core';
import { ClientMaster, SIDClientMaster } from '../models/client-master.model';
import { EmployeeProfile } from '../models/employee-profile.model';
import { SafeUrl } from '@angular/platform-browser';
import { Item } from '../../shared/dropdown/dropdown.models';

@Injectable({
  providedIn: 'root'
})
export class GlobalStoreService {

  clientMaster: ClientMaster;
  sidclientMaster: SIDClientMaster;
  photo: SafeUrl;
  profile: EmployeeProfile;
  loading: boolean;
  selectedReport: number;
  reportSource:Item[]=[];
  selectedReportSource:string='Drive Engineer Plan';
  sidDataFlag: boolean;
  regexValidator = '^[A-Za-z0-9()\r\n\t\=#$;+!@%&}{?:.,_ [-]+$';
  regexNumDecValidator = /^-?(0|[1-9]\d*)(\.\d+)?$/;
  regexValidatorSIDPrject = '^[A-Za-z0-9()\r\n\t\=#$;+!@%&}{?:.,_ [-]+$';
  constructor() {
    this.selectedReport = 1;
  }
}
